import type { StaticFieldSchema } from 'core/utils/generated/formSchemas'

import type { SchemaField } from './schema'
import { S } from 'core/helpers'

export const resolveComponentType = (args: {
  schemaField?: StaticFieldSchema
  fieldOverride?: SchemaField['component']
  runtimeComponent: SchemaField['component']
}): SchemaField['component'] =>
  args.fieldOverride || args.schemaField?.component || args.runtimeComponent

export const buildSelectOptions = (
  rawOptions: Array<string>,
): Array<{ label: string; value: string }> =>
  rawOptions.map((opt) => ({
    label: opt === '' ? '(None)' : S.sentenceCase(opt),
    value: opt,
  }))

export const normalizeSelectValueForForm = (value: unknown): unknown =>
  value === '' ? null : value

export const resolveNumberFormat = (
  schemaField?: StaticFieldSchema,
): 'integer' | 'float' | 'currency' => schemaField?.numberFormat || 'integer'

export const isFieldEditable = (field: SchemaField): boolean => {
  if (field.type === 'array') return true
  if (['string', 'number', 'boolean', 'enum'].includes(field.type)) return true
  return false
}

export const getFormKey = (
  parentPath: string | undefined,
  key: string,
): string => (parentPath ? `${parentPath}.${key}` : key)
